import React from 'react';
import '../less/okkoPromoMC.less';
import Link from 'MWComponents/dest/components/Link';
import mc_logo from '../img/Mastercard.svg';
import abank_logo from '../img/abank_logo.svg';
import usage_block_data from '../enums/usage_block_data.json';
import UsageBlock from '../../../../auxiliary-components/shared/UsageBlock';
import JoinToOffer from '../components/JoinToOffer';
import mc_logo_mobile from '../img/mc_logo_mobile.svg';
import abank_logo_mobile from '../img/abank_logo_mobile.svg';
import multiSelect from "MWComponents/dest/components/MultiSelect";



export default function template() {
    const isMobile = this.isViewportMobile(),
      thisYear = this.props.year,
      yearData = {
        bannerText: {
          '2023': 'OKKO_PROMO_BANNER_TEXT',
          '2024': 'OKKO_PROMO_BANNER_TEXT_2024',
          '2024_2': 'OKKO_PROMO_BANNER_TEXT_2024_2'
        },
        bannerSubtitle: {
          '2023': 'OKKO_PROMO_BANNER_SUBTITLE',
          '2024': 'OKKO_PROMO_BANNER_SUBTITLE_2024',
          '2024_2': 'OKKO_PROMO_BANNER_SUBTITLE_2024_2'
        },
        offerName: {
          '2023': 'okkopromomc',
          '2024': 'promomcokko2024',
          '2024_2': 'promomcokko2024'
        },
        discTex_3: {
          '2023': 'OKKO_PROMO_INFO_BLOCK_TEXT_03',
          '2024': 'OKKO_PROMO_INFO_BLOCK_TEXT_03_2024',
          '2024_2': 'OKKO_PROMO_INFO_BLOCK_TEXT_03_2024_2'
        },
        discTex_4: {
          '2023': 'OKKO_PROMO_INFO_BLOCK_TEXT_04',
          '2024': 'OKKO_PROMO_INFO_BLOCK_TEXT_04_2024',
          '2024_2': 'OKKO_PROMO_INFO_BLOCK_TEXT_04_2024_2'
        },
        file_url: {
          '2023': '/static/offers/okko_terms.pdf',
          '2024': '/static/offers/okko_terms_2024.pdf',
          '2024_2': '/static/offers/okko_terms_2024_2.pdf'
        }
      },
      bannerLeftSide = (
        isMobile ?
          <div className="banner-left-side">
            <div className="banner-left-side-text" dangerouslySetInnerHTML={{__html: this.l10n(yearData.bannerText[thisYear])}}></div>
            <div className="banner-left-side-logos" >
              <img src={mc_logo_mobile} alt="mc_logo" className="banner-left-side-logos-item" />
              <img src={abank_logo_mobile} alt="abank_logo" className="banner-left-side-logos-item" />
            </div>
            <div className="banner-left-side-title" dangerouslySetInnerHTML={{__html: isMobile ? this.l10n('OKKO_PROMO_BANNER_TITLE_MOB') : this.l10n('OKKO_PROMO_BANNER_TITLE')}}></div>
            <div className="banner-left-side-subtitle" dangerouslySetInnerHTML={{__html: this.l10n(yearData.bannerSubtitle[thisYear])}}></div>
          </div>
          :
          <div className="banner-left-side">
            <div className="banner-left-side-title" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_BANNER_TITLE')}}></div>
            <div className="banner-left-side-subtitle" dangerouslySetInnerHTML={{__html: this.l10n(yearData.bannerSubtitle[thisYear])}}></div>
            <div className="banner-left-side-logos" >
              <img src={mc_logo} alt="mc_logo" className="banner-left-side-logos-item" />
              <img src={abank_logo} alt="abank_logo" className="banner-left-side-logos-item" />
            </div>
            <div className="banner-left-side-text" dangerouslySetInnerHTML={{__html: this.l10n(yearData.bannerText[thisYear])}}></div>
          </div>
      )

    return (
        <div className="okko-promo-MC">
          <div className="banner">
            <div className="banner-content">
              {bannerLeftSide}
              <div className='banner-right-side'>
                <JoinToOffer closeModal={this.toggleModal} isMobile={isMobile} year={thisYear} offerName={yearData.offerName[thisYear]} utmParams={this.utmParams}/>
              </div>
            </div>
          </div>
          <div className='content'>
            <UsageBlock isMobile={isMobile} page={'good-deeds'} data={usage_block_data} className="col-3-row-1"></UsageBlock>
            <div className="discount-info-block" >
              <div className="discount-info-block-title" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_INFO_BLOCK_TEXT_01')}}></div>
              <div className="discount-info-block-text" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_INFO_BLOCK_TEXT_02')}}></div>
              <ul className="discount-info-block-list">
                <li className="discount-info-block-list-item" dangerouslySetInnerHTML={{__html: this.l10n(yearData.discTex_3[thisYear])}}></li>
                <li className="discount-info-block-list-item" dangerouslySetInnerHTML={{__html: this.l10n(yearData.discTex_4[thisYear])}}></li>
              </ul>
              <div className="discount-info-block-text" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_INFO_BLOCK_TEXT_05')}}></div>
              <div className="discount-info-block-text" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_INFO_BLOCK_TEXT_06')}}></div>
            </div>
            <div className="instruction-block">
              <div className="instruction-block-title" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_ISTRUCTION_BLOCK_TEXT_01')}}></div>
              <ul>
                <li className="instruction-block-list" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_ISTRUCTION_BLOCK_TEXT_02')}}></li>
                <li className="instruction-block-list" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_ISTRUCTION_BLOCK_TEXT_03')}}></li>
              </ul>
              <div className="instruction-block-text" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_ISTRUCTION_BLOCK_TEXT_04')}}></div>
              <div className="instruction-block-text" dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_ISTRUCTION_BLOCK_TEXT_05')}}></div>
            </div>
            <div className="documents">
                <div className="documents-title">{this.l10n('ACQUIRING_LEFT_DOC_TITLE')}</div>
                <div className="documents-item-wrapper">
                  <Link className="documents-item" href={yearData.file_url[thisYear]} target="_blank"
                        dangerouslySetInnerHTML={{__html: this.l10n('OKKO_PROMO_DOCS_ITEM_TEXT')}}>
                  </Link>
                </div>
              </div>
          </div>
    </div>
    );
}
